import React, { useEffect } from "react";
import HeaderSection from "../components/shared/HeaderSection";
import ServicesSection from "../components/pages/services/ServicesSection";
import { fetchServiceData } from "../redux/slices/ServicesSlice";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/shared/Loader";
import { useTranslation } from "react-i18next";
import MetaTags from "../components/shared/MetaTags";

const Services = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const { data, status, error } = useSelector((state) => state.services);
  useEffect(() => {
    dispatch(fetchServiceData());
  }, [dispatch]);

  if (status === "loading") {
    return <Loader />;
  }

  if (status === "failed") {
    return <div>Error: {error}</div>;
  }

  return (
    <>
      <MetaTags />
      <HeaderSection title={t("banner.ourservices")} />
      <ServicesSection data={data?.data?.services} />
    </>
  );
};

export default Services;
